import { useDevelopmentProgramCategories } from "@/lib/api";
import { MenuItem, Skeleton } from "@mui/material";
import PropTypes from "prop-types";
import SelectStyled from "../SelectStyled";

export const DevelopmentProgramCategorySelector = ({ name, label, onChange }) => {
    const { categories, isLoading, isError } = useDevelopmentProgramCategories();

    const handleSelected = (event) => {
        if (onChange) {
            onChange(event);
        }
    }

    if (isLoading) {
        return <Skeleton />
    }

    return (
        <>
            <SelectStyled
                fullWidth
                name={name}
                label={label}
                placeholder="Alle Förderarten"
                variant="filled"
                inputProps={{ "aria-label": "Art der Förderung" }}
                onChange={handleSelected}
                renderValue={e => e?.name ?? "Bitte wählen"}
            >
                <MenuItem value="">Alle Förderarten</MenuItem>
                {categories.map((category) => {
                    return <MenuItem key={category.id} value={category}>{category.name}</MenuItem>
                })}
            </SelectStyled>
        </>
    );
};

DevelopmentProgramCategorySelector.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func
};
